import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
import { cityOption } from '@/util/mainOption'
Vue.prototype.cityOption = cityOption

// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.use(ElementUI)
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
})
